import React from 'react';
import Styles from '../assets/css/utils/loader.module.scss';

const Loader = ({ size = 'medium', color = 'primary' }) => {
    return (
        <div className={`${Styles.loader} ${Styles[size]} ${Styles[color]}`}>
            <div className={Styles.spinner}></div>
        </div>
    );
};

export default Loader;